import { formatters } from '@app/ui';
import { Role, useGetContextQuery } from '@app/main/api';
import { useMemo, useRef } from 'react';
import { shallowEqual } from 'react-redux';

function useContext() {
  const { data } = useGetContextQuery();
  const context = data!;

  return useMemo(
    () =>
      Object.assign({}, context, {
        hasRole: (role: Role) => context.roles.includes(role),

        get name() {
          return formatters.name(context);
        },
      }),
    [context],
  );
}

export function useUserContextSelector<TResult>(
  select: (selectors: ReturnType<typeof useContext>) => TResult,
): TResult {
  const context = useContext();
  const prevRef = useRef<TResult>();

  const result = select(context);
  if (shallowEqual(result, prevRef.current)) {
    return prevRef.current!;
  }

  prevRef.current = result;
  return result;
}
